import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['StatusSummary'],
});

export const statusSummaryApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllStatusSummarys: builder.query({
      query: () => `status_summary/`,
      providesTags: ['StatusSummary'],
    }),
    findAllStatusSummaryBySelectionVl: builder.query({
      query: () => `status_summary/selection_data/vl/`,
      providesTags: ['StatusSummary'],
    }),
    findAllStatusSummaryBySelectionRegion: builder.query({
      query: () => `status_summary/selection_data/region/`,
      providesTags: ['StatusSummary'],
    }),

    findAllStatusSummaryByPermission: builder.query({
      query: (id) => `status_summary/permission/?yard_id=${id}`,
      providesTags: ['StatusSummary'],
    }),

    findAllStatusSummaryByPagination: builder.query({
      query: (payload) => {
        let url = `status_summary/summary/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      // providesTags: ['StatusSummary'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindAllStatusSummarysQuery } = statusSummaryApi;
